import { axios } from "@/plugins/axios";
import { objectCamelToKebap } from "@/utils/string";
import { DateFormatter } from "@/utils/date";

function sendVersicherungsfall(data = {}) {
    const {
        mode,
        formstep,
        rechtsschutzKfz,
        rechtsschutzLenker,
        geburtsdatum,
        unfallDatum,
        unfallUhrzeit,
        carglassVersicherungsart,
        modriveVersicherungsart,
    } = data;

    // unfallfotosEigene;
    // unfallfotosFremd;
    // unfallfotosSonstige;

    // let changedData = Object.assign({}, data);
    let changedData = JSON.parse(JSON.stringify(data));

    changedData.geburtsdatum = DateFormatter.formatDate(
        new Date(geburtsdatum),
        "DD.MM.YYYY"
    );
    changedData.unfallDatum = DateFormatter.formatDate(
        new Date(unfallDatum),
        "DD.MM.YYYY"
    );
    changedData.unfallUhrzeit = DateFormatter.formatDate(
        new Date(unfallUhrzeit),
        "HH:mm"
    );
    // changedData.unfallUhrzeit = unfallUhrzeit.substring(
    //     unfallUhrzeit.length,
    //     unfallUhrzeit.length - 5
    // );

    // console.log(changedData.geburtsdatum);

    // let geburtsdatumArray = geburtsdatum.slice(0, 10).split("-");
    // changedData.geburtsdatum =
    //     geburtsdatumArray[2] +
    //     "." +
    //     geburtsdatumArray[1] +
    //     "." +
    //     geburtsdatumArray[0];

    if (
        mode === "recht" &&
        formstep > 1 &&
        (rechtsschutzKfz === true || rechtsschutzLenker === true)
    ) {
        changedData.formstep--;
    }

    if (mode === "kfz") {
        if (carglassVersicherungsart === "Nur Haftpflicht") {
            changedData.carglass = "Nein";
        }
        if (
            modriveVersicherungsart === "Nur Haftpflicht" ||
            changedData.carglass === "Ja"
        ) {
            changedData.modrive = "Nein";
        }
        if (changedData.modrive !== "") {
            changedData.isModrivePossible = true;
        }
        if (formstep > 3) {
            if (changedData.carglass !== "") {
                changedData.formstep--;
            }

            if (changedData.carglass !== "Ja" && changedData.modrive !== "") {
                changedData.formstep--;
            }
        }
    }

    let kebapData = objectCamelToKebap(changedData);
    let formData = new FormData();
    for (let key in kebapData) {
        formData.append(key, kebapData[key]);
    }

    if (mode == "kfz") {
        for (let [index, file] of data.unfallfotosEigene.entries()) {
            formData.append("unfallfotos-eigene-" + index, file);
        }
        for (let [index, file] of data.unfallfotosFremd.entries()) {
            formData.append("unfallfotos-fremd-" + index, file);
        }
        for (let [index, file] of data.unfallfotosSonstige.entries()) {
            formData.append("unfallfotos-sonstige-" + index, file);
        }

        formData.append("beteiligte-anzahl", data.beteiligte.length);

        for (let beteiligteKey in data.beteiligte) {
            let kebapBeteiligte = objectCamelToKebap(
                data.beteiligte[beteiligteKey]
            );
            for (let beteiligteDataKey in kebapBeteiligte) {
                if (beteiligteDataKey == "geburtsdatum") {
                    formData.append(
                        "beteiligte-" + beteiligteDataKey + "-" + beteiligteKey,
                        DateFormatter.formatDate(
                            new Date(kebapBeteiligte[beteiligteDataKey]),
                            "DD.MM.YYYY"
                        )
                    );
                } else {
                    formData.append(
                        "beteiligte-" + beteiligteDataKey + "-" + beteiligteKey,
                        kebapBeteiligte[beteiligteDataKey]
                    );
                }
            }
        }
    }

    if (mode == "haushalt" || mode == "sach") {
        for (let [index, file] of data.schadensfotos.entries()) {
            formData.append("schadensfotos-" + index, file);
        }
    }

    if (mode == "recht") {
        formData.append("beschuldigtezeugen-anzahl", data.beteiligte.length);

        for (let beteiligteKey in data.beteiligte) {
            let kebapBeteiligte = objectCamelToKebap(
                data.beteiligte[beteiligteKey]
            );
            for (let beteiligteDataKey in kebapBeteiligte) {
                if (beteiligteDataKey == "geburtsdatum") {
                    formData.append(
                        "beschuldigtezeugen-" +
                            beteiligteDataKey +
                            "-" +
                            beteiligteKey,
                        DateFormatter.formatDate(
                            new Date(kebapBeteiligte[beteiligteDataKey]),
                            "DD.MM.YYYY"
                        )
                    );
                } else {
                    formData.append(
                        "beschuldigtezeugen-" +
                            beteiligteDataKey +
                            "-" +
                            beteiligteKey,
                        kebapBeteiligte[beteiligteDataKey]
                    );
                }
            }
        }
    }

    // if (mode == "sach") {
    //     for (let [index, file] of data.unfallfotosEigene.entries()) {
    //         formData.append("schadensfotos-" + index, file);
    //     }
    // }
    // Display the key/value pairs
    // for (var pair of formData.entries()) {
    //     console.log(pair[0] + ": " + pair[1]);
    // }
    return axios.post("?Mode=General&Function=SendVersicherungsfall", formData);
}

function sendVersicherungsfallV2(data = {}) {
    // Kopie der Originaldaten zum Verändern
    let changedData = JSON.parse(JSON.stringify(data));

    // Datum formatieren
    if (data.geburtsdatum) {
        changedData.geburtsdatum = DateFormatter.formatDate(
            new Date(data.geburtsdatum),
            "DD.MM.YYYY"
        );
    }
    if (data.unfallDatum) {
        changedData.unfallDatum = DateFormatter.formatDate(
            new Date(data.unfallDatum),
            "DD.MM.YYYY"
        );
    }
    if (data.unfallUhrzeit) {
        changedData.unfallUhrzeit = DateFormatter.formatDate(
            new Date(data.unfallUhrzeit),
            "HH:mm"
        );
    }
    if (data.von) {
        changedData.von = DateFormatter.formatDate(
            new Date(data.von),
            "DD.MM.YYYY"
        );
    }
    if (data.bis) {
        changedData.bis = DateFormatter.formatDate(
            new Date(data.bis),
            "DD.MM.YYYY"
        );
    }

    // Mo'Drive
    if (data.mode === "kfz") {
        if (data.modriveVersicherungsart === "Nur Haftpflicht") {
            changedData.modrive = "Nein";
        }
        if (changedData.modrive !== "") {
            changedData.isModrivePossible = true;
        }
    }

    // Objekt in FormData umwandeln
    let kebapData = objectCamelToKebap(changedData);
    let formData = new FormData();
    for (let key in kebapData) {
        formData.append(key, kebapData[key]);
    }

    // Bilder anhängen
    if (data.unfallfotosEigene) {
        for (let [index, file] of data.unfallfotosEigene.entries()) {
            formData.append("unfallfotos-eigene-" + index, file);
        }
    }
    if (data.unfallfotosFremd) {
        for (let [index, file] of data.unfallfotosFremd.entries()) {
            formData.append("unfallfotos-fremd-" + index, file);
        }
    }
    if (data.unfallfotosSonstige) {
        for (let [index, file] of data.unfallfotosSonstige.entries()) {
            formData.append("unfallfotos-sonstige-" + index, file);
        }
    }
    if (data.unfallbericht) {
        for (let [index, file] of data.unfallbericht.entries()) {
            formData.append("unfallbericht-" + index, file);
        }
    }
    if (data.kostenvoranschlag) {
        for (let [index, file] of data.kostenvoranschlag.entries()) {
            formData.append("kostenvoranschlag-" + index, file);
        }
    }
    if (data.kostenvoranschlagFremd) {
        for (let [index, file] of data.kostenvoranschlagFremd.entries()) {
            formData.append("kostenvoranschlag-fremd-" + index, file);
        }
    }
    if (data.polizeiDokumente) {
        for (let [index, file] of data.polizeiDokumente.entries()) {
            formData.append("polizei-dokumente-" + index, file);
        }
    }
    if (data.schadensfotos) {
        for (let [index, file] of data.schadensfotos.entries()) {
            formData.append("schadensfotos-" + index, file);
        }
    }
    if (data.aufenthaltsbestaetigung) {
        for (let [index, file] of data.aufenthaltsbestaetigung.entries()) {
            formData.append("aufenthaltsbestaetigung-" + index, file);
        }
    }

    // Beteiligte anhängen
    if (data.beteiligte) {
        formData.append("beteiligte-anzahl", data.beteiligte.length);
        for (let beteiligteKey in data.beteiligte) {
            let kebapBeteiligte = objectCamelToKebap(
                data.beteiligte[beteiligteKey]
            );
            for (let beteiligteDataKey in kebapBeteiligte) {
                if (beteiligteDataKey == "geburtsdatum") {
                    formData.append(
                        "beteiligte-" + beteiligteDataKey + "-" + beteiligteKey,
                        DateFormatter.formatDate(
                            new Date(kebapBeteiligte[beteiligteDataKey]),
                            "DD.MM.YYYY"
                        )
                    );
                } else {
                    formData.append(
                        "beteiligte-" + beteiligteDataKey + "-" + beteiligteKey,
                        kebapBeteiligte[beteiligteDataKey]
                    );
                }
            }
        }
    }

    // Beteiligte Fahrzeuge anhängen
    if (data.beteiligteFahrzeuge) {
        formData.append(
            "beteiligtefahrzeuge-anzahl",
            data.beteiligteFahrzeuge.length
        );
        for (let beteiligteKey in data.beteiligteFahrzeuge) {
            let kebapBeteiligte = objectCamelToKebap(
                data.beteiligteFahrzeuge[beteiligteKey]
            );
            for (let beteiligteDataKey in kebapBeteiligte) {
                if (beteiligteDataKey == "geburtsdatum") {
                    formData.append(
                        "beteiligtefahrzeuge-" +
                            beteiligteDataKey +
                            "-" +
                            beteiligteKey,
                        DateFormatter.formatDate(
                            new Date(kebapBeteiligte[beteiligteDataKey]),
                            "DD.MM.YYYY"
                        )
                    );
                } else {
                    formData.append(
                        "beteiligtefahrzeuge-" +
                            beteiligteDataKey +
                            "-" +
                            beteiligteKey,
                        kebapBeteiligte[beteiligteDataKey]
                    );
                }
            }
        }
    }

    // Display the key/value pairs
    if (!Capacitor.isNative) {
        for (var pair of formData.entries()) {
            console.log(pair[0] + ": " + pair[1]);
        }
    }

    return axios.post(
        "?Mode=General&Function=SendVersicherungsfallV2",
        formData
    );
}

export { sendVersicherungsfall, sendVersicherungsfallV2 };
